import Vue from 'vue';
import VueTimepicker from 'vue2-timepicker';

Vue.component('vue-timepicker', VueTimepicker);
